<template>
    <div v-if="isShow" style="width: 300px;height: 60%;z-index: 99999;position: absolute;left: 30%;top: 20%;background-color: rgb(220,220,220,0.5);">
        <Tree class="treeStyle" :data="treeData" @on-select-change="onChange"></Tree>
        <div style="position: absolute;bottom: 10px;right: 20px;">
            <Button type="success" @click="onOk">选择</Button>
            <Button type="error" @click="onCancel">放弃</Button>
        </div>
    </div>
</template>
<style>
.treeStyle ul {
    text-align: left;
}
</style>
<script>
    export default {
        name : "alarmIdsShow",
        mounted : function(){
            this.$store.registerModule(['system','alarmIdsShow'],{
                state : {
                    $ : this
                }
            });
        },
        data : function(){
            return {
                selectedValue : "",
                isShow : false,
                treeData : [{
                    title: '模型',
                    expand: true,
                    children: []
                }]
            }
        },
        methods : {
            show(type,ids,callback){
                this.type = type;
                this.treeData = [{
                    title: '模型',
                    expand: true,
                    children: []
                }];
                var tempAllModel = {};
                for(var i = 0; i < ids.length; i++){
                    if(tempAllModel[ids[i].model]){
                        if(tempAllModel[ids[i].model][ids[i].rule]){
                            tempAllModel[ids[i].model][ids[i].rule].push({
                                title: new Date(ids[i].time).format("yyyy-MM-dd hh:mm:ss"),
                                id:ids[i].id
                            });
                        }else{
                            tempAllModel[ids[i].model][ids[i].rule] = [];
                            tempAllModel[ids[i].model][ids[i].rule].push({
                                title: new Date(ids[i].time).format("yyyy-MM-dd hh:mm:ss"),
                                id:ids[i].id
                            });
                        }
                    }else{
                        tempAllModel[ids[i].model] = {};
                        tempAllModel[ids[i].model][ids[i].rule] = [];
                        tempAllModel[ids[i].model][ids[i].rule].push({
                                title: new Date(ids[i].time).format("yyyy-MM-dd hh:mm:ss"),
                                id:ids[i].id
                            });
                    }
                }

                for(var p in tempAllModel){
                    var data = {
                        title:p,
                        children:[]
                    }
                    for(var p1 in tempAllModel[p]){
                        var item = {
                            title :p1,
                            parentName : p
                        }
                        if(type == "alarm"){
                            item.children = tempAllModel[p][p1]
                        }
                        data.children.push(item);
                    }
                    this.treeData[0].children.push(data);
                }
                this.isShow = true;
                this.onComplete = callback;
            },
            onOk(){
                if(this.type == "alarm" && (!this.selectedValue || this.selectedValue == "")){
                    this.$Message.info(this.$store.state.system.$.languageName == "ch" ?"必须选中一条报警，仅选中模型或规则无效":"An alarm must be selected. Selecting only the model or rule does not work");
                    return;
                }else if(!this.selectedValue || this.selectedValue == ""){
                    this.$Message.info(this.$store.state.system.$.languageName == "ch" ?"至少选中一个模型":"Select at least one model");
                }
                this.isShow = false;
                this.onComplete(this.selectedValue);
            },
            onCancel(){
                this.isShow = false;
                this.onComplete("");
            },
            onChange(item){
                if(item.length ==0) return;
                if(this.type == "alarm"){
                    this.selectedValue = item[0].id;
                }else{
                    if(item[0].nodeKey == 2)
                        this.selectedValue = item[0].parentName + "." + item[0].title;
                    else
                        this.selectedValue = item[0].title;
                }
            }
        }
        
    }
</script>


// WEBPACK FOOTER //
// src/components/system/alarmIdsShow.vue